// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__I1UYJ","TextModal":"Modal_TextModal__sIG-a","ModalBG":"Modal_ModalBG__-VfB3"};